var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#help-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.9 9.095a8.29 8.29 0 0 0 8.3 8.301c4.6 0 8.3-3.717 8.3-8.301s-3.7-8.3-8.3-8.3a8.29 8.29 0 0 0-8.3 8.3Zm1.6 0c0-3.667 3-6.64 6.7-6.64s6.6 2.973 6.6 6.64c0 3.668-2.9 6.64-6.6 6.64-3.7 0-6.7-2.972-6.7-6.64Zm7.1.885c0 .302-.3.569-.6.569h-.1c-.3 0-.6-.255-.6-.569l-.1-.79c-.1-.384.1-.651.5-.697 1-.128 1.5-.442 1.5-1.011v-.024c0-.523-.4-.825-1.1-.825-.5 0-.9.151-1.3.465-.2.105-.4.186-.6.186-.4 0-.8-.372-.8-.813 0-.221.1-.454.3-.628.7-.511 1.4-.837 2.5-.837 1.6 0 2.8.86 2.8 2.406v.023c0 1.476-1.1 2.08-2.3 2.336l-.1.209Zm-1.7 2.347v-.023c0-.558.4-.988 1-.988s1 .43 1 .988v.023c0 .558-.4.988-1 .988s-1-.43-1-.988Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "help-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h17v18H0z"
})))));
export { SvgHelpIcon as ReactComponent };
export default __webpack_public_path__ + "images/help-icon.svg";